import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Asset, Device } from "@/domain";
interface AssetState {
  overrides: Record<string, Partial<Pick<Asset, "name" | "groupId" | "type">>>;
  registrations: { asset: Asset; device: Device }[];
  syncMinutes: Record<string, 10 | 60>;
  update: (
    id: string,
    patch: Partial<Pick<Asset, "name" | "groupId" | "type">>,
  ) => void;
  register: (asset: Asset, device: Device) => void;
  setSync: (deviceId: string, minutes: 10 | 60) => void;
}
export const useAssetStore = create<AssetState>()(
  persist(
    (set) => ({
      overrides: {},
      registrations: [],
      syncMinutes: {},
      update: (id, patch) =>
        set((s) => ({
          overrides: { ...s.overrides, [id]: { ...s.overrides[id], ...patch } },
        })),
      register: (asset, device) =>
        set((s) => ({
          registrations: [...s.registrations, { asset, device }],
        })),
      setSync: (id, minutes) =>
        set((s) => ({ syncMinutes: { ...s.syncMinutes, [id]: minutes } })),
    }),
    { name: "latisent-assets-v2" },
  ),
);
